import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { Button, Grid } from 'semantic-ui-react';

import { makeSelectCalibrations } from 'services/equipmentSets/selectors';
import {
    EquipmentSetId,
    Calibration,
    CalibrationId
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    SprayEntityIds,
    SprayApplicationRate
} from 'services/sprayEvents/types';
import isEqual from 'lodash.isequal';

interface OwnProps {
    equipmentSetId: EquipmentSetId;
    entityIds?: SprayEntityIds;
    applicationRate?: SprayApplicationRate;
}

interface DispatchProps {
    setSelectedCalibrationId: Function;
    selectedCalibrationId?: CalibrationId;
}

interface ConnectedProps {
    calibrations?: Calibration[];
}

export type Props = ConnectedProps & OwnProps & DispatchProps;

export class RangeComponent extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { calibrations, setSelectedCalibrationId } = this.props;

        if (calibrations && calibrations.length) {
            setSelectedCalibrationId(calibrations[0].id);
        }
    }

    componentDidUpdate(prevProps: Props): void {
        const { calibrations, setSelectedCalibrationId } = this.props;

        if (
            calibrations &&
            !isEqual(calibrations, prevProps.calibrations) &&
            calibrations.length
        ) {
            setSelectedCalibrationId(calibrations[0].id);
        }
    }

    handleClick = (selectedCalibrationId: number): void => {
        this.props.setSelectedCalibrationId(selectedCalibrationId);
    };

    render(): ReactElement | null {
        const { calibrations, selectedCalibrationId } = this.props;

        if (calibrations && calibrations.length > 1) {
            return (
                <Grid.Row>
                    <Grid.Column>
                        <Button.Group
                            fluid
                            primary
                            size="medium"
                            className="calibration-range"
                        >
                            {calibrations.map(
                                ({
                                    id,
                                    rowSpacingMin,
                                    rowSpacingMax
                                }: Calibration): ReactElement => (
                                    <Button
                                        key={id}
                                        type="button"
                                        primary
                                        basic={id !== selectedCalibrationId}
                                        onClick={(): void =>
                                            this.handleClick(id)
                                        }
                                    >
                                        {`${rowSpacingMin} - ${rowSpacingMax} m`}
                                    </Button>
                                )
                            )}
                        </Button.Group>
                    </Grid.Column>
                </Grid.Row>
            );
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, ConnectedProps>({
    calibrations: makeSelectCalibrations()
});

export default connect(mapStateToProps)(RangeComponent);
